import React, { useEffect, useState, useRef } from 'react'
import { Formik } from "formik";
import { Grid, TextField, MenuItem, Typography, Paper, Button, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Dialog, DialogTitle, DialogActions } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import * as yup from 'yup';
import { Link, useNavigate, useParams } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import "../../App.css"
import Form from 'react-bootstrap/Form';
import useRequestResource from '../../hooks/useRequestResource';
import ColorPicker from "../../components/ColorPicker";
import { FormatLineSpacing } from '@mui/icons-material';
import DropdownSelect from '../../components/utils/DropdownSelect';
import InfiniteScroll from 'react-infinite-scroll-component';
import DatePicker from 'react-datepicker';


const validationSchema = yup.object({
    device_eui: yup.string().required("Device EUI is required").max(255, "Max Length is 255!"),
    application_eui: yup.string().required("Application EUI is required").max(255, "Max Length is 255!"),
    application_key: yup.string().required("Application Key is required").max(255, "Max Length is 255!"),
    rx_window: yup.string().required("Rx Window is required").max(255, "Max Length is 255!"),
    rx2_frequency_MHz: yup.string().required("Rx2 frequency is required")
    .test('number', 'Rx2 frequency must be a number', (value) => {
        if (value) {
            const pattern = /^-?\d+(?:\.\d+)?$/;
            return pattern.test(value);
        }
        return true;
    })
    .test('decimal-places', 'Rx2 frequency must have at most 3 decimal places', (value) => {
        if (value) {
        const pattern = /^-?\d+(\.\d{1,3})?$/;
        return pattern.test(value);
        }
        return true;
    }),
    rx2_data_rate: yup.string().required("Rx2 data rate is required").max(255, "Max Length is 255!"),
    kerlink_class: yup.string().max(255, "Max Length is 255!"),
    device_type: yup.string().max(255, "Max Length is 255!"),
})

const CreateKerlinkDevice = () => {
    const groupInfiniteScrollRef = useRef(null); 
    const userInfiniteScrollRef = useRef(null);
    const accessGroupTextField = useRef(null); 
    const accessUserTextField = useRef(null); 
    const { getResourceList: getAccessGroupList, resourceList: accessGroupList, currentListSize: currentAccessGroupListSize } = useRequestResource({ endpoint: "auth", query: "accessgroups", resourceLabel: "Access Group List" });
    const { getResourceList: getAccessUserList, resourceList: accessUserList, currentListSize: currentAccessUserListSize } = useRequestResource({ endpoint: "auth", query: "users", resourceLabel: "User List" });
    const { addResource }  = useRequestResource({ endpoint: "auth", query: "kerlink_device", resourceLabel: "Kerlink Device" });
    const navigate = useNavigate();
    const [ showGroupInfiniteScroll, setGroupInfiniteScroll ] = useState(false)
    const [ showUserInfiniteScroll, setUserInfiniteScroll ] = useState(false)
    const [ accessGroups, setAccessGroups ] = useState([])
    const [ accessUsers, setAccessUsers ] = useState([])
    let offset = 25;

    const deviceTypeOptions = [
        { value: 'OTAA', label: 'OTAA' },
        { value: 'ABP', label: 'ABP' }
    ]

    const [initialValues, setInitialValues] = useState({
        device_eui: "",
        application_eui: "",
        application_key: "",
        rx_window: "",
        rx2_frequency_MHz: "",
        rx2_data_rate: "",
        kerlink_class: "",
        device_type: "",
        access_groups: [],
        access_users: [],
    });

    const fetchGroupData = () => {
        getAccessGroupList(offset)
    }

    const fetchUserData = () => {
        getAccessUserList(offset)
    }

    useEffect(() => {
        getAccessGroupList();
        getAccessUserList();
    }, [getAccessGroupList, getAccessUserList])

    useEffect(() => {
        // Add a click event listener to the document
        document.addEventListener('click', handleOutsideClick);
        return () => {
          // Clean up the click event listener on component unmount
          document.removeEventListener('click', handleOutsideClick);
        };
      }, []); // Run the effect only once during component mount


      const handleOutsideClick = (event) => {
        // Check if the clicked element is within the InfiniteScroll container or its children
        if (groupInfiniteScrollRef.current && !groupInfiniteScrollRef.current.contains(event.target)) {
            if (accessGroupTextField.current && accessGroupTextField.current.contains(event.target)) {
                return; // Do nothing if the clicked element is the excluded component
              }
          setGroupInfiniteScroll(false); // Close the InfiniteScroll
        }

        if (userInfiniteScrollRef.current && !userInfiniteScrollRef.current.contains(event.target)) {
            if (accessUserTextField.current && accessUserTextField.current.contains(event.target)) {
                return; // Do nothing if the clicked element is the excluded component
              }
          setUserInfiniteScroll(false); // Close the InfiniteScroll
        }
      };

    const handleSubmit = values => {
        const formattedValues = {
            device_eui: values.device_eui ? values.device_eui : null,
            application_eui: values.application_eui ? values.application_eui : null,
            application_key: values.application_key ? values.application_key : null,
            rx_window: values.rx_window ? values.rx_window : null,
            rx2_frequency_MHz: values.rx2_frequency_MHz ? values.rx2_frequency_MHz : null,
            rx2_data_rate: values.rx2_data_rate ? values.rx2_data_rate : null,
            kerlink_class: values.kerlink_class ? values.kerlink_class : null,
            device_type: values.device_type ? values.device_type : null,
            access_groups: accessGroups.map(obj => obj.id),
            access_users: accessUsers.map(obj => obj.id)
        }
        addResource(formattedValues, () => {
            navigate(`/kerlinkdevices`)
        })
    }

    function addGroup(group) {
        const unique = {}
        const results = []
        for (const geo of accessGroups) {
            const key = geo.id
            unique[key] = true;
            results.push(geo)

        }
        const key = group.id
        if (!unique[key]) {
            results.push(group)
        }
        setAccessGroups(results)
    }

    function deleteGroup(option) {
        const set = new Set([...accessGroups])
        set.delete(option)
        setAccessGroups([...set])
    }

    const access_groups_list = 
    (
        <Grid item xs={12}>
            {accessGroups.map((option, index) => {
                return (
                    <MenuItem>
                        <Grid item xs={12}>
                            {option.label}
                            <IconButton size="small" onClick={() => {deleteGroup(option)}}>
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </MenuItem>
                )   
            })}
        </Grid>
    )

    function addUser(user) {
        const unique = {}
        const results = []
        for (const geo of accessUsers) {
            const key = geo.id
            unique[key] = true;
            results.push(geo)

        }
        const key = user.id
        if (!unique[key]) {
            results.push(user)
        }
        setAccessUsers(results)
    }

    function deleteUser(option) {
        const set = new Set([...accessUsers])
        set.delete(option)
        setAccessUsers([...set])
    }

    const access_users_list = 
    (
        <Grid item xs={12}>
            {accessUsers.map((option, index) => {
                return (
                    <MenuItem>
                        <Grid item xs={12}>
                            {option.first_name} {option.last_name}
                            <IconButton size="small" onClick={() => {deleteUser(option)}}>
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </MenuItem>
                )   
            })}
        </Grid>
    )

    return (
        <div style={{alignItems: "start"}}>
            <Paper sx={{
                borderRadius: "2px",
                bpxShadow: (theme) => theme.shadows[4],
                padding: (theme) => theme.spacing(2, 4, 3)
            }}>

                <Grid item>
                    <Box sx={{ display: "flex", margin: (theme) => theme.spacing(1), marginTop: (theme) => theme.spacing(3) }} />
                </Grid>
                <Typography variant="h6" mh={4}>
                    Kerlink Device Information
                </Typography>

                <br />
            <Formik onSubmit={handleSubmit}
                    initialValues={initialValues}
                    enableReinitialize
                    validationSchema={validationSchema}
                >
                    {
                        (formik) => {
                            return <form onSubmit={formik.handleSubmit} style={{textAlign: "start"}}>
                                <Grid container spacing={3} style={{alignItems: "start"}}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="device_eui"
                                            label="Device EUI"
                                            {...formik.getFieldProps('device_eui')}
                                            error={formik.touched.device_eui && Boolean(formik.errors.device_eui)}
                                            helperText={formik.touched.device_eui && formik.errors.device_eui}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="application_eui"
                                            label="Application EUI"
                                            {...formik.getFieldProps('application_eui')}
                                            error={formik.touched.application_eui && Boolean(formik.errors.application_eui)}
                                            helperText={formik.touched.application_eui && formik.errors.application_eui}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="application_key"
                                            label="Application Key"
                                            {...formik.getFieldProps('application_key')}
                                            error={formik.touched.application_key && Boolean(formik.errors.application_key)}
                                            helperText={formik.touched.application_key && formik.errors.application_key}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="rx_window"
                                            label="Rx Window"
                                            {...formik.getFieldProps('rx_window')}
                                            error={formik.touched.rx_window && Boolean(formik.errors.rx_window)}
                                            helperText={formik.touched.rx_window && formik.errors.rx_window}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="rx2_frequency_MHz"
                                            label="Rx2 Frequency"
                                            {...formik.getFieldProps('rx2_frequency_MHz')}
                                            error={formik.touched.rx2_frequency_MHz && Boolean(formik.errors.rx2_frequency_MHz)}
                                            helperText={formik.touched.rx2_frequency_MHz && formik.errors.rx2_frequency_MHz}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="rx2_data_rate"
                                            label="Rx2 Data Rate"
                                            {...formik.getFieldProps('rx2_data_rate')}
                                            error={formik.touched.rx2_data_rate && Boolean(formik.errors.rx2_data_rate)}
                                            helperText={formik.touched.rx2_data_rate && formik.errors.rx2_data_rate}
                                        >
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="kerlink_class"
                                            label="Kerlink Class"
                                            {...formik.getFieldProps('kerlink_class')}
                                            error={formik.touched.kerlink_class && Boolean(formik.errors.kerlink_class)}
                                            helperText={formik.touched.kerlink_class && formik.errors.kerlink_class}
                                        />
                                    </Grid>
                                    
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="device_type"
                                            label="Device Type"
                                            {...formik.getFieldProps('device_type')}
                                            select
                                            value={formik.values.device_type}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                            }}
                                            error={formik.touched.device_type && Boolean(formik.errors.device_type)}
                                            helperText={formik.touched.device_type && formik.errors.device_type}
                                        >
                                            {deviceTypeOptions.map((option, index) => (
                                                <MenuItem key={index} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>


                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            autoComplete='off'
                                            id="access_groups"
                                            label="Access Groups"
                                            value=""
                                            ref={accessGroupTextField}
                                            onClick={() => setGroupInfiniteScroll(true)}
                                            error={formik.touched.access_groups && Boolean(formik.errors.access_groups)}
                                            helperText={formik.touched.access_groups && formik.errors.access_groups}
                                        >
                                        </TextField>
                                    </Grid>
                                        

                                    { showGroupInfiniteScroll ? <Grid item xs={12}>

                                    <div ref={groupInfiniteScrollRef}>
                                    <InfiniteScroll
                                                dataLength={accessGroupList.results.length}
                                                next={fetchGroupData}
                                                hasMore={currentAccessGroupListSize.current >= offset}
                                                loader={<h4>Loading...</h4>}
                                                height={400}
                                                endMessage={
                                                    <p style={{ textAlign: "center" }}>
                                                    <b>Yay! You have seen it all</b>
                                                    </p>
                                                }>
                                                
                                                {accessGroupList.results.map((option, index) => {
                                                    return (
                                                    <MenuItem key={index} value={option.id} onClick={
                                                        () => {
                                                            addGroup(option)
                                                        }
                                                    }>
                                                        {option.label}
                                                    </MenuItem>
                                                    );}
                                                )}

                                            </InfiniteScroll>
                                            </div>
                                    </Grid> : <div></div>}

                                    <Grid item xs={12}>
                                        {access_groups_list}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            autoComplete='off'
                                            id="access_users"
                                            label="Access Users"
                                            value=""
                                            ref={accessUserTextField}
                                            onClick={() => setUserInfiniteScroll(true)}
                                            error={formik.touched.access_users && Boolean(formik.errors.access_users)}
                                            helperText={formik.touched.access_users && formik.errors.access_users}
                                        >
                                        </TextField>
                                    </Grid>
                                        

                                    { showUserInfiniteScroll ? <Grid item xs={12}>

                                    <div ref={userInfiniteScrollRef}>
                                    <InfiniteScroll
                                                dataLength={accessUserList.results.length}
                                                next={fetchUserData}
                                                hasMore={currentAccessUserListSize.current >= offset}
                                                loader={<h4>Loading...</h4>}
                                                height={400}
                                                
                                                endMessage={
                                                    <p style={{ textAlign: "center" }}>
                                                    <b>Yay! You have seen it all</b>
                                                    </p>
                                                
                                                }>
                                                
                                                {accessUserList.results.map((option, index) => {
                                                    return (
                                                    <MenuItem key={index} value={option.id} onClick={
                                                        () => {
                                                            addUser(option)
                                                        }
                                                    }>
                                                        {option.first_name} {option.last_name}
                                                    </MenuItem>
                                                    );}
                                                )}

                                            </InfiniteScroll>
                                            </div>
                                    </Grid> : <div></div>}

                                    <Grid item xs={12}>
                                        {access_users_list}
                                    </Grid>


                                <Grid item xs={12} >
                                    <Button component={Link}
                                        to={`/kerlinkdevices`}
                                        size="medium"
                                        variant="contained"
                                        color="primary"
                                        sx = {{ mr: 2 }}
                                    >
                                        Back
                                    </Button>

                                    <Button
                                        // type="submit"
                                        onClick={() => {handleSubmit(formik.values)}}
                                        size="medium"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Create New Kerlink Device
                                    </Button>

                                </Grid>
                            </Grid>
                            </form>
                        }
                    }
                </Formik>
                </Paper>
        </div>
    )
}

export default CreateKerlinkDevice